import Chip from '@material-ui/core/Chip';
import { green, lightGreen, red } from '@material-ui/core/colors';
import { makeStyles } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward';
import clsx from 'clsx';
import { ReactElement, ReactNode } from 'react';

export type DeltaChipProps = {
  value: number;
  label: ReactNode;
  tooltip?: ReactNode;
  className?: string;
};

const useStyles = makeStyles(
  {
    negative: {
      color: green[900],
      backgroundColor: lightGreen[200],
    },
    positive: {
      color: red[900],
      backgroundColor: red[100],
    },
  },
  {
    name: 'DeltaChip',
  },
);

/**
 * Badge for a signed delta: green with a down arrow when the value is negative,
 * red with an up arrow otherwise. Positioning is left to the caller via className.
 */
export const DeltaChip = ({ value, label, tooltip, className }: DeltaChipProps): ReactElement => {
  const classes = useStyles();
  const isNegative = value < 0;

  const chip = (
    <Chip
      size="small"
      className={clsx(className, isNegative ? classes.negative : classes.positive)}
      label={label}
      icon={isNegative ? <ArrowDownwardIcon /> : <ArrowUpwardIcon />}
    />
  );

  return tooltip ? <Tooltip title={tooltip}>{chip}</Tooltip> : chip;
};
